// extracted by mini-css-extract-plugin
export default {"product-image":"ManageProductReservationDetail_product-image__3Oz4v"};